import React, { ReactNode } from "react";

interface Props {
  children?: ReactNode;
  title?: string;
  placeholder?: string;
  phone?: boolean;
  style?: object;
}
export default function CustomInput({
  children,
  title,
  placeholder,
  style,
}: Props) {
  return (
    <div className="custom-input" style={style}>
      <div className="title">{title}</div>
      <input
        type="text"
        placeholder={placeholder}
        className="custom-input__input"
      />
    </div>
  );
}
